import * as React from 'react';
import {Redirect} from 'react-router';
import { withRouter, RouteComponentProps } from 'react-router-dom';

import {connect} from '../../stores/GlobalStore';

export interface Props extends RouteComponentProps<any> {
  authToken: string,
  children: React.ReactNode,
}

function LoggedIn(props: Props) {
  const { authToken, children, history } = props;

  if (!authToken) {
    return <Redirect to={'/login?redirect_to=' + encodeURIComponent(history.location.pathname)} />;
  }

  return children;
}

export default withRouter(
  connect(LoggedIn, 'authToken')
);
